import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { PostDto } from '../../../api/interfaces/Posts';
import { useLoader } from '../../../Loader/LoaderContext';
import { getService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import {
  getDotColor,
  getStatusClass,
  getStatusDisplayName,
} from '../../../utility/RolesUtility';
import DateService from '../../../servce/DateService';
import ReadMore from '../leads/ReadMore';
const AVERAGE_READ_TIME_WPM = 200;
const ViewDetails: React.FC = () => {
  const [companyData, setcompanyData] = useState<any>(null);
  const location = useLocation();
  const path = location.pathname;
  const [data, setData] = useState<any>();
  const { setLoading } = useLoader();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('appUserId');
  const nameOfScreen = searchParams.get('name');
  const navigate = useNavigate();
  useEffect(() => {
    fetchVehicles();
  }, []);
  const getCompanyDetails = async (responseData: any) => {
    try {
      let url: any;
      if (
        responseData?.companyRespDto?.vendorType === 'HOSPITAL' &&
        responseData?.companyRespDto?.recordType === 'VENDOR'
      ) {
        url = API_ENDPOINTS.hospitalProfilling;
      } else if (
        responseData?.companyRespDto?.vendorType === 'COMPANY' &&
        responseData?.companyRespDto?.recordType === 'VENDOR'
      ) {
        url = API_ENDPOINTS.companyProfilling;
      } else if (
        responseData?.companyRespDto?.vendorType === 'EVENT_ORGANIZER' &&
        responseData?.companyRespDto?.recordType === 'VENDOR'
      ) {
        url = API_ENDPOINTS.eventProfilling;
      }

      if (responseData) {
        const response = await getService(
          `${url}?vendorId=${responseData?.companyRespDto?.id}`
        );
        setcompanyData(response.data);
      }
    } catch (error) {
      console.error('Error parsing stored data:', error);
    }
  };
  const fetchVehicles = async () => {
    setLoading(true);
    try {
      let url: any;
      let screen;
      // url = API_ENDPOINTS.getPostsDetails
      if (userInfo.roles === 'CHIEF_EDITOR') {
        url = API_ENDPOINTS.getPostsDetailsCheif;
      } else if (userInfo.roles === 'JUNIOR_EDITOR') {
        url = API_ENDPOINTS.getPostsDetails;
      } else if (userInfo.roles === 'UPLOADER') {
        url = API_ENDPOINTS.getPostsDetailsUploader;
      } else if (userInfo.roles === 'PUBLISHER') {
        url = API_ENDPOINTS.getPostsDetailsPublisher;
      } else if (userInfo.roles === 'CONTENT_ADMIN') {
        url = API_ENDPOINTS.getCAPostDetails;
      } else {
        screen = 'viewDahboard';
        url = API_ENDPOINTS.post;
      }

      const response = await getService(url + '?id=' + userId);
      console.log(response);
      setData(response.data);
      getCompanyDetails(response.data);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const users = () => {
    if (nameOfScreen === 'viewPost') {
      navigate('/portals/posts/viewPosts');
    } else if (nameOfScreen === 'archived') {
      navigate('/portals/posts/archived');
    } else if (nameOfScreen === 'events') {
      navigate('/portals/posts/viewEventsPosts');
    } else if (nameOfScreen === 'expiredEvents') {
      navigate('/portals/posts/expiredEventsPosts');
    } else if (
      path === '/vendorDashboard/activateDashbord/contentMarketing/viewPost'
    ) {
      navigate('/vendorDashboard/activateDashbord/contentMarketing');
    } else if (nameOfScreen === 'enquiryevents') {
      navigate('/portals/enquiries/events');
    } else if (nameOfScreen === 'enquiryPost') {
      navigate('/portals/enquiries/posts');
    }
  };
  // const modifyContentForStyles = (content:string) => {
  //   // This function will add classes to your headings and paragraphs
  //   return content
  //     .replace(/<h1/g, '<h1 style="font-size: 2rem;')
  //     .replace(/<h2/g, '<h2 style="font-size: 2rem;')
  //     .replace(/<p/g, '<p class="ql-size-small"')
  //     .replace(/<strong/g, '<strong class="font-bold"') // If you have a class for strong
  //     // Add more replacements as necessary
  // };

  // const contentWithClasses = modifyContentForStyles(data?.actualContent || '');
  // const calculateReadingTime = (title = '', description = '', content = ''): string => {
  //   const combinedText = [title, description, content].join(' ').replace(/[^a-zA-Z0-9\s]/g, '');
  //   const wordCount = combinedText.trim().split(/\s+/).length;
  //   const readingTime = Math.ceil(wordCount / AVERAGE_READ_TIME_WPM);
  //   return readingTime > 0 ? `${readingTime} min read` : '1 min read';
  // };
  const calculateReadingTime = (
    title = '',
    description = '',
    content = ''
  ): string => {
    // Combine all the text and strip out any HTML tags
    const combinedText = [title, description, content]
      .join(' ')
      .replace(/<\/?[^>]+(>|$)/g, '') // Strip HTML tags
      .replace(/[^a-zA-Z0-9\s]/g, ''); // Remove non-alphanumeric characters

    const wordCount = combinedText.trim().split(/\s+/).length;
    const readingTime = Math.ceil(wordCount / AVERAGE_READ_TIME_WPM);
    return readingTime > 0 ? `${readingTime} min read` : '1 min read';
  };

  const getCategories: Record<string, string> = {
    IUI: 'IUI',
    IVF: 'IVF',
    HOSPITAL: 'Hospital',
    SURROGACY_CENTER: 'Surrogacy Center',
    SPERM_OR_EGG_FREEZING: 'Sperm/ Egg freezing',
  };
  const handleEdit = (data: any) => {
    console.log('Edit clicked, data:', data);

    // Validation: Ensure data contains a valid ID
    if (!data?.id) {
      console.error('Post ID is undefined');
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const name = params.get('name');
    if (data?.type === 'EVENT') {
      const navigateUrl = `/portals/posts/addEvents?appUserId=${data?.id}${
        name ? `&name=${name}` : ''
      }`;
      navigate(navigateUrl);
    } else {
      const navigateUrl = `/portals/posts/createPost?appUserId=${data?.id}${
        name ? `&name=${name}` : ''
      }`;
      navigate(navigateUrl);
    }
  };
  const [isPlaying, setIsPlaying] = useState(false);

  // Convert YouTube URL to Embed URL
  // const convertToEmbedUrl = (url: string) => {
  //   const embedUrl = url.replace('watch?v=', 'embed/');
  //   return embedUrl;
  // };

  const extractVideoId = (urlObj: URL): string => {
    try {
      let videoId = '';

      if (
        urlObj.hostname === 'www.youtube.com' ||
        urlObj.hostname === 'youtube.com'
      ) {
        videoId = urlObj.searchParams.get('v') || '';
      } else if (urlObj.hostname === 'youtu.be') {
        videoId = urlObj.pathname.slice(1);
      }

      if (!videoId) {
        throw new Error('Invalid YouTube URL: Video ID not found');
      }

      return videoId;
    } catch (error) {
      console.log(error, 'ID not generated');
      return '';
    }
  };

  const convertToEmbedUrl = (url: string): string => {
    try {
      const urlObj = new URL(url);
      let videoId = extractVideoId(urlObj);

      const listParam = urlObj.searchParams.get('list');
      const indexParam = urlObj.searchParams.get('index');
      // Build embed URL

      let embedUrl = `https://www.youtube.com/embed/${videoId}`;
      const embedParams = new URLSearchParams();

      embedParams.set('autoplay', '1');

      // Add playlist parameters if present
      if (listParam) {
        embedParams.set('list', listParam);
      }
      if (indexParam) {
        embedParams.set('index', indexParam);
      }

      // Append parameters if any exist
      const paramString = embedParams.toString();
      if (paramString) {
        embedUrl += `?${paramString}`;
      }

      console.log(embedUrl);

      return embedUrl;
    } catch (error) {
      console.log(error, 'YT Video not converted');
      return '';
    }
  };

  const getThumbnail = (url: string): string => {
    try {
      const urlObj = new URL(url);
      const videoId = extractVideoId(urlObj);

      return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    } catch (error) {
      console.log(error, 'Thumbnail not generated');
      return '';
    }
  };

  return (
    <div className='h-full py-2 w-full'>
      <div className='flex justify-between mb-3 mr-[15px]'>
        <div className='flex items-center cursor-pointer'>
          <h2
            className='mr-2 text-gray-700 font-semibold text-sm'
            onClick={users}
          >
            {nameOfScreen === 'viewPost'
              ? 'Posts'
              : nameOfScreen === 'archived'
              ? 'Archived'
              : nameOfScreen === 'events' || nameOfScreen === 'expiredEvents'
              ? 'Events'
              : 'Posts'}
          </h2>
          <img src='/images/arrowIcons.svg' className='mr-2' />{' '}
          <span className='text-gray-400 font-semibold text-sm truncate max-w-[800px] lg:max-w-[600px] md:max-w-[400px] sm:max-w-[200px]'>
            {data?.title}
          </span>
        </div>
        {data?.isEditable && (
          <div
            onClick={() => handleEdit(data)}
            className='flex items-center gap-2 cursor-pointer bg-white px-3 rounded-md border border-gray-300'
          >
            {' '}
            <img src='/images/editIcon.svg' />
            <a
              href='#'
              className='block py-2 text-sm text-[#374151] font-normal '
            >
              Edit Post
            </a>
          </div>
        )}
      </div>
      <div className=''>
        <div className='w-full flex gap-8'>
          <div className='w-[85%] sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4 bg-white  px-8  pt-6 scroolCls rounded-lg'>
            <div className=''>
              <div className='flex items-center space-x-4 mb-5'>
                <p className='text-[#B00A2B] font-normal mb-0'>
                  {data?.category ? getCategories[data.category] : ''}
                </p>
                <div className='flex justify-end items-center'>
                  <span>
                    <span
                      className={`px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusClass(
                        data?.status
                      )}`}
                    >
                      <span
                        className='inline-block w-2 h-2 mr-2 rounded-full'
                        style={{ backgroundColor: getDotColor(data?.status) }}
                      ></span>
                      {/* {data?.status ? 'Active' : 'Inactive'} */}
                      {userInfo.roles === 'PUBLISHER' &&
                      data?.status === 'TO_PUBLISHER_APPROVE' ? (
                        `Received for Approval`
                      ) : userInfo.roles === 'UPLOADER' &&
                        data?.status === 'TO_JE_APPROVE' ? (
                        <>Sent for Approval to Junior Editor</>
                      ) : userInfo.roles === 'JUNIOR_EDITOR' &&
                        data?.status === 'TO_JE_APPROVE' ? (
                        `Received for Approval`
                      ) : (userInfo.roles === 'UPLOADER' ||
                          userInfo.roles === 'JUNIOR_EDITOR') &&
                        data?.status === 'ASSIGNED_TO_JE' ? (
                        <>Assigned to {data?.assignedTo}{data?.assignedTo !== 'You' && '(JE)'}</>
                      ) : (userInfo.roles === 'UPLOADER' ||
                          userInfo.roles === 'JUNIOR_EDITOR') &&
                        data?.status === 'TO_CE_APPROVE' ? (
                        <>Sent for Approval to Chief Editor</>
                      ) : (userInfo.roles === 'UPLOADER' ||
                          userInfo.roles === 'JUNIOR_EDITOR' ||
                          userInfo.roles === 'CHIEF_EDITOR') &&
                        data?.status === 'TO_PUBLISHER_APPROVE' ? (
                        `Sent for Approval to Publisher`
                      ) : userInfo.roles === 'CHIEF_EDITOR' &&
                        data?.status === 'TO_CE_APPROVE' ? (
                        `Received for Approval`
                      ) : userInfo.roles === 'PUBLISHER' &&
                        data?.status === 'TO_PUBLISHER_APPROVE' ? (
                        `Received for Approval`
                      ) : (userInfo.roles === 'PUBLISHER' ||
                          userInfo.roles === 'CHIEF_EDITOR' ||
                          userInfo.roles === 'JUNIOR_EDITOR' ||
                          userInfo.roles === 'UPLOADER') &&
                        data?.status === 'ASSIGNED_TO_PUBLISHER' ? (
                        <>Assigned to {data?.assignedTo}{data?.assignedTo !== 'You' && ' (PUBL)'}</>
                      ) : (
                        getStatusDisplayName(data?.status)
                      )}
                      {/* {userInfo.roles === 'PUBLISHER' &&
                      data?.status === 'TO_PUBLISHER_APPROVE' ? (
                        `Received for Approval`
                      ) : userInfo.roles === 'UPLOADER' &&
                        data?.status === 'TO_JE_APPROVE' ? (
                        <>Sent for Approval </>
                      ) : userInfo.roles === 'JUNIOR_EDITOR' &&
                        data?.status === 'TO_JE_APPROVE' ? (
                        `Received for Approval`
                      ) : (userInfo.roles === 'UPLOADER' ||
                          userInfo.roles === 'JUNIOR_EDITOR') &&
                        data?.status === 'ASSIGNED_TO_JE' ? (
                        <>Assigned to {data?.assignedTo}</>
                      ) : (userInfo.roles === 'UPLOADER' ||
                          userInfo.roles === 'JUNIOR_EDITOR') &&
                        data?.status === 'TO_CE_APPROVE' ? (
                        <>Sent for Approval to {data?.ceName || ''} </>
                      ) : (userInfo.roles === 'UPLOADER' ||
                          userInfo.roles === 'JUNIOR_EDITOR' ||
                          userInfo.roles === 'CHIEF_EDITOR') &&
                        data?.status === 'TO_PUBLISHER_APPROVE' ? (
                        `Sent for Approval to Publisher`
                      ) : userInfo.roles === 'CHIEF_EDITOR' &&
                        data?.status === 'TO_CE_APPROVE' ? (
                        `Received for Approval`
                      ) : userInfo.roles === 'PUBLISHER' &&
                        data?.status === 'TO_PUBLISHER_APPROVE' ? (
                        `Received for Approval`
                      ) : (userInfo.roles === 'PUBLISHER' ||
                          userInfo.roles === 'CHIEF_EDITOR' ||
                          userInfo.roles === 'JUNIOR_EDITOR' ||
                          userInfo.roles === 'UPLOADER') &&
                        data?.status === 'ASSIGNED_TO_PUBLISHER' ? (
                        <>Assigned to {data?.assignedTo} </>
                      ) : (
                        getStatusDisplayName(data?.status)
                      )} */}
                      <span className='ml-1'>on </span>
                      <span>
                        {data?.lastActionAt
                          ? DateService.formatDate(
                              data?.lastActionAt,
                              DateService.formats.DD_MM_YYYY
                            )
                          : 'NA'}
                      </span>
                      {/* {getStatusDisplayName(data?.status)} */}
                    </span>
                    {/* <p className="text-end text-gray-500 text-[10px] mt-1">
  {(userInfo.roles === 'CHIEF_EDITOR' && data?.status === 'TO_CE_APPROVE') || (userInfo.roles === 'JUNIOR_EDITOR' && data?.status === 'TO_JE_APPROVE')  || ((userInfo.roles === 'PUBLISHER') && data?.status === 'TO_PUBLISHER_APPROVE') || (userInfo.roles === 'PUBLISHER' && data?.status === 'TO_PUBLISHER_APPROVE')
    ? `From ${data?.sendForApprvlBy}}` 
    : ((userInfo.roles === 'CHIEF_EDITOR' ||  userInfo.roles === 'UPLOADER') && data?.status !=='SAVED_AS_DRAFT')  || userInfo?.roles ==='JUNIOR_EDITOR' ? <>by {data?.lastActionBy}</> :''
  }
  
</p> */}
                  </span>
                </div>
                {/* <div>
                  <span className={`px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusClass(data?.status)}`}>
                  <span className="inline-block w-2 h-2 mr-2 rounded-full" style={{ backgroundColor: getDotColor(data?.status) }}></span>
                    {data?.assignedTo ? `Assigned to  ${data?.assignedTo}` :getStatusDisplayName(data?.status)}
                    <span className='ml-2'>on </span>
                    <span>{data?.lastActionAt ? data?.lastActionAt : 'NA'}</span>
                  </span>
                </div>  */}
              </div>
              <p className='font-bold text-3xl pb-3'>{data?.title}</p>
              <p className='text-lg  font-normal w-[100%] text-gray-800 break-words '>
                {data?.description}
              </p>
              <div className='flex item-center justify-between bg-[#FFF7F7] p-4 rounded-[8px] my-2'>
                <div className='flex items-center'>
                  {/* <img src='' className='size-[32px] mr-2' />
                  <h2 className='text-gray-900 font-bold text-base'>Rasika Gayakavad</h2> */}
                  <div className='ml-3 flex items-center'>
                    {/* <span className='w-[6px] h-[6px] bg-gray-400 rounded-full block mr-1'></span> */}
                    <h2 className='text-gray-800 text-base font-normal'>
                      {data?.addedOn
                        ? DateService.formatDate(
                            data?.addedOn,
                            DateService.formats.DD_MM_YYYY
                          )
                        : 'NA'}
                    </h2>
                  </div>
                  <div className='ml-3 flex items-center'>
                    <span className='w-[6px] h-[6px] bg-gray-400 rounded-full block mr-3'></span>
                    <h2 className='text-gray-800 text-base font-normal'>
                      {calculateReadingTime(
                        data?.title,
                        data?.description,
                        data?.actualContent
                      )}
                    </h2>
                  </div>
                </div>
                <div className='flex items-center gap-4'>
                  {/* <img src='/images/videoFrame.svg' className='size-[24px] mr-2' /> */}
                  {/* <img src='/images/frameSave.svg' className='size-[24px] mr-2' />
                  <img src='/images/Share.svg' className='size-[24px] mr-2' /> */}
                </div>
              </div>
              {data?.type !== 'VIDEO' &&
                data?.type !== 'INTERVIEW' &&
                data?.type != 'WEBINAR' &&
                data?.imageDto?.documentUrl && (
                  <img
                    src={
                      data?.imageDto?.documentUrl
                        ? data?.imageDto?.documentUrl
                        : ''
                    }
                    className='w-[100%] h-auto'
                    alt='doctor'
                  />
                )}
              {(data?.type === 'VIDEO' ||
                data?.type === 'INTERVIEW' ||
                data?.type == 'WEBINAR') &&
                data?.videoLink && (
                  // <div>
                  //   <iframe
                  //   width="560"
                  //   height="315"
                  //   src={convertToEmbedUrl(data?.videoLink) || ''}
                  //   title="YouTube video player"
                  //   frameBorder="0"
                  //   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  //   allowFullScreen
                  // ></iframe>
                  //   </div>
                  <div className='relative w-full pb-[56.25%]'>
                    {!isPlaying ? (
                      <div className='absolute inset-0 flex items-center justify-center bg-black'>
                        {/* Video Thumbnail */}
                        {/* <img 
                        src={`https://img.youtube.com/vi/${
                            data?.videoLink.split('v=')[1]
                          }/maxresdefault.jpg`}
                          alt='Video Thumbnail'
                          className='w-full h-full object-cover'
                        /> */}
                        <img
                          src={getThumbnail(data?.videoLink)}
                          alt='Video Thumbnail'
                          className='w-full h-full object-cover'
                        />

                        {/* Custom Play Icon */}
                        <button
                          className='absolute bg-white p-8 rounded-full shadow-lg'
                          onClick={() => setIsPlaying(true)}
                        >
                          <img
                            src='/images/videoPlayBtn.svg'
                            alt='Play Button'
                            className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 md:w-16 md:h-16'
                          />
                          {/* <img
          src="/your-play-icon.svg" // Path to your custom play icon
          alt="Play"
          className="w-16 h-16"
        /> */}
                        </button>
                      </div>
                    ) : (
                      // Video iframe
                      // <iframe
                      //   className='absolute top-0 left-0 w-full h-full'
                      //   src={`${convertToEmbedUrl(data?.videoLink)}?autoplay=1`}
                      //   title='YouTube Video Player'
                      //   frameBorder='0'
                      //   allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      //   allowFullScreen
                      // ></iframe>
                      <iframe
                        className='absolute top-0 left-0 w-full h-full'
                        src={`${convertToEmbedUrl(data?.videoLink)}`}
                        title='YouTube Video Player'
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                      ></iframe>
                    )}
                  </div>
                )}

              <h2 className='text-gray-500 font-normal text-[10px] mb-5 mt-1'>
                {data?.imageCaption}
              </h2>
              <div
                className='pb-4 py-2 break-words ContentPost'
                dangerouslySetInnerHTML={{
                  __html:
                    data?.actualContent
                      ?.replace(
                        /<iframe/g,
                        '<div class="video-container"><iframe'
                      )
                      ?.replace(/<\/iframe>/g, '</iframe></div>')
                      // Preserve empty paragraphs and breaks
                      ?.replace(
                        /<p>\s*<\/p>/g,
                        '<p class="empty-paragraph">&nbsp;</p>'
                      )
                      ?.replace(
                        /<p><br\s*\/?><\/p>/g,
                        '<p class="preserved-break">&nbsp;</p>'
                      ) || '',
                }}
              />
            </div>
          </div>
          <div
            className='sm:grid h-[50%] grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4 scroolCls rounded-lg'
            style={{ width: '30%' }}
          >
            {/* <div className='bg-white py-6 px-8 rounded-lg'>
              <p className='text-2xl font-bold text-gray-900 mb-5'>Author Details</p>
              <div className='flex items-center mb-6'>
                  <img src='' className='size-[32px] mr-2' />
                  <div>
                  <h2 className='text-gray-900 font-bold text-base'>Rasika Gayakavad</h2>
                  <p className='font-semibold text-sm text-[#374151]'>APC Company</p>
                  </div>
                </div>
              <p>Rasika is a lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. </p>
            </div>
            <div className='bg-white py-6 px-8 rounded-lg'>
              <p className='text-2xl font-bold text-gray-900 mb-5'>Author Details</p>
              <h2 className='text-gray-900 font-bold text-2xl'>ABC Company</h2>
              <p>ABC Company is a lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.  </p>
            </div> */}
            {(data?.authorDto || data?.leaderShipTeamDto) && (
              <div className='border border-gray-200 rounded-lg p-3 md:p-5 bg-white py-6 px-8 mb-3'>
                <p className='text-2xl font-bold text-gray-900 mb-5'>
                  Author Details
                </p>
                <div className='flex items-center mb-6'>
                  <img
                    src={
                      data?.authorDto?.imageDto?.documentUrl ||
                      data?.leaderShipTeamDto?.fileDto?.documentUrl ||
                      '/images/dummpComapnyLogo.svg'
                    }
                    className='size-[32px] mr-2 rounded-full'
                  />
                  <div>
                    <h2 className='text-gray-900 font-bold text-base'>
                      {data?.authorDto?.name || data?.leaderShipTeamDto?.name}
                    </h2>
                    <p className='font-semibold text-sm text-[#374151]'>
                      {data?.companyName}
                    </p>
                  </div>
                </div>
                <p>
                  <ReadMore
                    text={
                      data?.authorDto?.bio ||
                      data?.leaderShipTeamDto?.bio ||
                      'NA'
                    }
                    lines={2}
                  />
                </p>
              </div>
            )}

            {(data?.companyRespDto?.name || companyData?.name) && (
              <>
                <div className='border border-gray-200 rounded-lg p-3 md:p-5'>
                  <div className='flex items-center'>
                    <img
                      src={
                        data?.companyRespDto?.imageDto?.documentUrl
                          ? data?.companyRespDto?.imageDto?.documentUrl
                          : companyData?.imageDto?.documentUrl
                          ? companyData?.imageDto?.documentUrl
                          : '/images/dummpComapnyLogo.svg'
                      }
                      className='size-[56px] rounded-full border border-gray-100'
                      alt=''
                    />
                    <h2 className='text-gray-900 font-bold text-base break-words ml-3 m-0 min-[1980px]:text-xl'>
                      {data?.companyRespDto?.name || companyData?.name}{' '}
                    </h2>
                  </div>
                  {(companyData?.companyInfo || companyData?.hospitalInfo) && (
                    <p>
                      <ReadMore
                        text={
                          companyData?.hospitalInfo ||
                          companyData?.companyInfo ||
                          'NA'
                        }
                        lines={2}
                      />
                    </p>
                  )}
                </div>
              </>
            )}
            <div className='bg-white py-6 px-6 rounded-lg mx-[13px] font-Inter'>
              <p className='text-2xl font-bold text-gray-900 mb-5'>
                SEO Meta Details
              </p>
              <div className='font-Inter'>
                <h2 className='text-[#374151] font-semibold text-base mb-1'>
                  Meta Title
                </h2>
                <p className='font-normal text-sm text-[#374151] mb-5'>
                  {data?.seoMetaTitle ? data?.seoMetaTitle : 'NA'}
                </p>
                <h2 className='text-[#374151] font-semibold text-base mb-1'>
                  Meta Description
                </h2>
                <p className='font-normal text-sm text-[#374151] mb-5'>
                  {data?.seoDescription ? data?.seoDescription : 'NA'}
                </p>
                <h2 className='text-[#374151] font-semibold text-base mb-1'>
                  Keywords
                </h2>
                <p className='font-normal text-sm text-[#374151] mb-5'>
                  {data?.keyWords ? data?.keyWords : 'NA'}{' '}
                </p>
                {/* <div>
                  <h2 className='text-[#374151] font-semibold text-base mb-1'>Tags</h2>
                  <p className='font-normal text-sm text-[#374151] mb-5 bg-[#F3F4F6] rounded-xl w-[30%] py-1 px-4'>IVF</p>
                  </div> */}
                <h2 className='text-[#374151] font-semibold text-base mb-1'>
                  Keyphrases
                </h2>
                <p className='font-normal text-sm text-[#374151]'>
                  {data?.seoAltText ? data?.seoAltText : 'NA'}
                </p>
              </div>
            </div>
            {/* <div className="bg-[#F5F5F5] px-4">
              <img src="/images/advertaisements.png" alt="" />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDetails;
